"use client";

import { c as _c } from "react/compiler-runtime";
import { getOrigin } from "@website/utils/channel/get-origin";
import { isChannel } from "@website/utils/channel/helpers";
import { AgenciesButton } from "@website/widget/header/components/agencies/agencies-button";
import { BackButton } from "@website/widget/header/components/back/back-button";
import { Logo } from "@website/widget/header/components/logo/logo";
import { MyTrips } from "@website/widget/header/components/my-trips/my-trips";
import { SupportAgent } from "@website/widget/header/components/support-agent/support-agent";
import { TravelServicesMobileDrawer } from "@website/widget/header/components/travel-services/TravelServicesMobileDrawer";
import { TravelServicesDesktop } from "@website/widget/header/components/travel-services/travel-services-desktop";
import { HeaderLogin } from "@website/widget/header/header-login/header-login";
import { HeaderPropertiesType } from "@website/widget/header/header.types";
import { LoginModal } from "@website/widget/login";
import { Suspense } from "react";
import { SnappIrTravelServicesDesktop } from "./components/travel-services/Snapp-ir-travel-services-desktop";
import { SnappIrTravelServicesMobileDrawer } from "./components/travel-services/SnappIrTravelServicesMobileDrawer";
export const Header = t0 => {
  const $ = _c(49);
  const {
    showBackButton: t1,
    isHomePage: t2,
    minimalView,
    hideBackButton,
    title,
    customTitle,
    minimalLogo,
    disableLogoURL: t3,
    fullWidth: t4
  } = t0;
  const showBackButtonParameter = t1 === undefined ? false : t1;
  const isHomePage = t2 === undefined ? false : t2;
  const disableLogoURL = t3 === undefined ? false : t3;
  const fullWidth = t4 === undefined ? false : t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = isChannel(["jek"]);
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  const isJek = t5;
  let t6;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = isChannel(["jek"]);
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const isAndroidOrWebApp = t6;
  const showBackButton = !hideBackButton && (showBackButtonParameter || isJek || isAndroidOrWebApp && !isHomePage);
  const showAppModeTitle = (isJek || isAndroidOrWebApp) && Boolean(title);
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = isChannel(["b2b", "website", "telesale", "web-app", "android", "safarmarket", "jek"]);
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  const showAuth = t7;
  let t8;
  if ($[3] !== isHomePage) {
    t8 = !isChannel(["in-store"]) && isHomePage;
    $[3] = isHomePage;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  const showSupportAgent = t8;
  let t9;
  if ($[5] !== minimalView) {
    t9 = !minimalView && isChannel(["website"]);
    $[5] = minimalView;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  const showAgenciesButton = t9;
  let t10;
  if ($[7] !== minimalView) {
    t10 = !minimalView && isChannel(["website", "telesale", "web-app", "android", "safarmarket", "jek"]);
    $[7] = minimalView;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  const showMyTrips = t10;
  let t11;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = process.env.CHANNEL === "snapp-ir-hotel" || getOrigin() === "https://hotel.snapp.ir";
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  const isSnappHotel = t11;
  let t12;
  if ($[10] !== minimalView) {
    t12 = !minimalView && isChannel(["website", "telesale", "web-app", "android", "safarmarket"]);
    $[10] = minimalView;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  const showTravelServices = t12;
  const t13 = `mx-0 flex size-full items-center gap-2 lg:gap-4 xl:mx-auto ${fullWidth ? "" : "xl:w-[1200px]"}`;
  let t14;
  if ($[12] !== isHomePage || $[13] !== showBackButton) {
    t14 = showBackButton && <Suspense><BackButton isHomePage={isHomePage} /></Suspense>;
    $[12] = isHomePage;
    $[13] = showBackButton;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== showTravelServices) {
    t15 = showTravelServices && <TravelServicesMobileDrawer />;
    $[15] = showTravelServices;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = isSnappHotel && <SnappIrTravelServicesMobileDrawer />;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== customTitle || $[19] !== disableLogoURL || $[20] !== minimalLogo || $[21] !== showAppModeTitle || $[22] !== title) {
    t17 = showAppModeTitle ? <div className="text-headline-6 font-normal">{title}</div> : <><Logo minimalLogo={minimalLogo} disableURL={disableLogoURL} />{Boolean(customTitle) && <><div className="bg-outline-thin -ms-1 me-1 h-[32px] w-px lg:-ms-2 lg:me-0 lg:h-[40px]" /><div className="text-on-surface-medium-emphasis text-sm font-bold lg:text-base">{customTitle}</div></>}</>;
    $[18] = customTitle;
    $[19] = disableLogoURL;
    $[20] = minimalLogo;
    $[21] = showAppModeTitle;
    $[22] = title;
    $[23] = t17;
  } else {
    t17 = $[23];
  }
  let t18;
  if ($[24] !== showTravelServices) {
    t18 = showTravelServices && <TravelServicesDesktop />;
    $[24] = showTravelServices;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== showAgenciesButton) {
    t19 = showAgenciesButton && <AgenciesButton />;
    $[26] = showAgenciesButton;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = isSnappHotel && <SnappIrTravelServicesDesktop />;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== t14 || $[30] !== t15 || $[31] !== t17 || $[32] !== t18 || $[33] !== t19) {
    t21 = <nav className="flex h-full items-center gap-2 lg:gap-4">{t14}{t15}{t16}{t17}{t18}{t19}{t20}</nav>;
    $[29] = t14;
    $[30] = t15;
    $[31] = t17;
    $[32] = t18;
    $[33] = t19;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="flex-1" />;
    $[35] = t22;
  } else {
    t22 = $[35];
  }
  let t23;
  if ($[36] !== showMyTrips) {
    t23 = showMyTrips && <Suspense><MyTrips /></Suspense>;
    $[36] = showMyTrips;
    $[37] = t23;
  } else {
    t23 = $[37];
  }
  let t24;
  if ($[38] !== showSupportAgent) {
    t24 = showSupportAgent && <Suspense fallback={null}><SupportAgent /></Suspense>;
    $[38] = showSupportAgent;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = showAuth && <Suspense><HeaderLogin /></Suspense>;
    $[40] = t25;
  } else {
    t25 = $[40];
  }
  let t26;
  if ($[41] !== t13 || $[42] !== t21 || $[43] !== t23 || $[44] !== t24) {
    t26 = <div className={t13}>{t21}{t22}{t23}{t24}{t25}</div>;
    $[41] = t13;
    $[42] = t21;
    $[43] = t23;
    $[44] = t24;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Suspense><LoginModal /></Suspense>;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== t26) {
    t28 = <div className="border-b-outline-thin relative z-30 flex h-16 w-full border-b bg-white px-4 lg:z-40 lg:px-6 xl:px-10">{t26}{t27}</div>;
    $[47] = t26;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  return t28;
};